import React, { ReactNode } from 'react';
import { DataRoomRFICategory } from 'router/subrouters/DataRoom/models/DataRoomRfi';
import {
  CategoryCellProps,
  TruncatedTextWithCount,
  NameCell,
  FilesCell,
  UploadedOnCell,
  StatusCell,
} from '../../../data/sharedCells';
import { getArrayLength, getHasElementsInArray } from 'utils';

export type RfiChecklistCategoryTableRow = Pick<DataRoomRFICategory, 'name'> &
  Record<'files' | 'uploadedBy' | 'uploadedOn' | 'status', string>;

export const TABLE_COLUMNS: Array<keyof RfiChecklistCategoryTableRow> = [
  'name',
  'files',
  'uploadedBy',
  'uploadedOn',
  'status',
];

export const HEADING_TRANSLATIONS: Record<
  keyof RfiChecklistCategoryTableRow,
  string
> = {
  name: 'document',
  files: 'uploadedFile',
  uploadedBy: 'uploadedBy',
  uploadedOn: 'uploadedOn',
  status: 'status',
};

export const SORTING_VALUES: Partial<
  Record<keyof RfiChecklistCategoryTableRow, string>
> = {
  name: 'name',
  uploadedBy: 'uploadedBy',
  uploadedOn: 'uploadedOn',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<keyof RfiChecklistCategoryTableRow, number>
> = {
  name: 280,
  files: 280,
  uploadedBy: 200,
  uploadedOn: 150,
  status: 130,
};

const UploadedByCell: React.FC<CategoryCellProps> = ({ category }) => {
  const { uploadedBy } = category;

  if (!getHasElementsInArray(uploadedBy)) return <p>/</p>;

  return (
    <TruncatedTextWithCount
      text={uploadedBy[0]?.email}
      count={getArrayLength(uploadedBy)}
    />
  );
};

export const BODY_CONTENT_GENERATE: Record<
  keyof RfiChecklistCategoryTableRow,
  (cellProps: CategoryCellProps) => ReactNode
> = {
  name: (cellProps) => <NameCell {...cellProps} />,
  files: (cellProps) => <FilesCell {...cellProps} />,
  uploadedBy: (cellProps) => <UploadedByCell {...cellProps} />,
  uploadedOn: (cellProps) => <UploadedOnCell {...cellProps} />,
  status: (cellProps) => <StatusCell {...cellProps} />,
};
